import { EntityTypeOld, ErrorStateOld } from "Store/interfaces/products";

export type GetVeteranVehicleModelsEntity = EntityTypeOld<
  VeteranModel[],
  OperationType
>;

export interface VeteranModel {
  readonly name: string;
  readonly modelsLink: string | null;
}

export type GetVeteranVehicleModelsError = ErrorStateOld<OperationType>;

export enum OperationType {
  GET_VETERAN_AUTO_MODELS = "GET_VETERAN_AUTO_MODELS",
  GET_VETERAN_MOPED_MODELS = "GET_VETERAN_MOPED_MODELS",
  GET_VETERAN_MOTORCYCLE_MODELS = "GET_VETERAN_MOTORCYCLE_MODELS",
}
